import React, { useEffect, useState } from 'react';
import CreateLeaderboardPage from './CreateLeaderboardPage';
import { useParams } from 'react-router-dom';
import api, {
	CreateLeaderboardRequest,
	LeaderboardDto,
	LeaderboardV2Dto,
} from '../../../api';
import { useSelector } from 'react-redux';
import { projectSelector } from '../../../redux/selectors/projectSelector';

type ParamsProps = {
	projectId: string;
	apiName: string;
};

export default function EditLeaderboardPage() {
	const [leaderboard, setLeaderboard] = useState<LeaderboardV2Dto>();
	const apiName = useParams<ParamsProps>().apiName;
	const project = useSelector(projectSelector);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		const getLeaderboard = async () => {
			if (project?.productId) {
				setLoading(true);
				const leaderboard = await api
					.getLeaderboardDetails({
						productId: project.productId,
						apiName,
					})
					.finally(() => {
						setLoading(false);
					});
				setLeaderboard(leaderboard);
			}
		};

		getLeaderboard();
	}, []);

	return <CreateLeaderboardPage leaderboard={leaderboard} loading={loading} />;
}
